import { render, staticRenderFns } from "./ItemDialogPoint.vue?vue&type=template&id=3862745d&scoped=true"
import script from "./ItemDialogPoint.vue?vue&type=script&lang=ts"
export * from "./ItemDialogPoint.vue?vue&type=script&lang=ts"
import style0 from "./ItemDialogPoint.vue?vue&type=style&index=0&id=3862745d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3862745d",
  null
  
)

export default component.exports